"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityNamedQuery = void 0;
var client_1 = require("@apollo/client");
var entityNamedQuery = function (defn, context) {
  return (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query ", "NamedQuery($name: String!) {\n      ", "Named(name: $name) {\n        id\n        name\n        slug\n        sid\n        openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }\n        ", "\n      }\n    }\n  "], ["\n    query ", "NamedQuery($name: String!) {\n      ", "Named(name: $name) {\n        id\n        name\n        slug\n        sid\n        openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }\n        ", "\n      }\n    }\n  "])), defn.leadingPluralTypeName, defn.leadingPluralTypeName, defn.namedQueryFields || '');
};
exports.entityNamedQuery = entityNamedQuery;
var templateObject_1;